<template>
  <div class="printManagementDialog">
    <el-dialog
      title="模型详情"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="900px"
    >
      <div class="dialogContent">
        <div class="dialogDetails">
          <p class="dialogName">模型名称：</p>
          <p>是个模型</p>
        </div>
        <div class="dialogDetails">
          <p class="dialogName">一级分类：</p>
          <p>家具用品</p>
        </div>
        <div class="dialogDetails">
          <p class="dialogName">二级分类：</p>
          <p>家具</p>
        </div>
        <div class="dialogDetails">
          <p class="dialogName">作者昵称：</p>
          <p>Alice</p>
        </div>
        <div class="dialogDetails">
          <p class="dialogName">模型金额：</p>
          <p>免费</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "materialManagementDialog",
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    init(type, id) {
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped lang="less">
.dialogContent {
  padding: 0 5%;
  .dialogDetails {
    display: flex;
    align-items: center;
    .dialogName {
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/model/modelDetails.vue